import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { BaseComponent } from '../../../../shared/utils/base.component';
import { NgZorroModule } from '../../../../shared/modules/ng-zorro/ng-zorro.module';
import { CommonModule } from '@angular/common';
import { AuthorizeFieldViewDirective } from '../../../../shared/authorization/authorizeFieldView.directive';
import { PROVIDER_TYPES, STATIC_DATA } from '../../../../shared/constants/static-data.constants';
import { Program } from '../../../../interfaces/user.interface';
import { UserService } from '../../../../services/user.service';
import { LeadDetailsService } from '../../../../services/lead-details.service';

@Component({
  selector: 'ppl-lead-payment-method',
  standalone: true,
  imports: [NgZorroModule, CommonModule, AuthorizeFieldViewDirective],
  templateUrl: './lead-payment-method.component.html',
  styleUrl: './lead-payment-method.component.css'
})
export class LeadPaymentMethodComponent extends BaseComponent implements OnInit {
 

  @Input() pageId = '';
  @Input() tabId = '';
  @Input() entry = '';
  @Input() program !: Program;
  paymentInfo?: any;
  
  constructor(private userService: UserService, private leadDetailsService: LeadDetailsService,
  ){
    super();
  }

  ngOnInit(): void {
    this.loadPaymentInfo();
  }

  loadPaymentInfo() {
    const id = this.userService.getSelectedLead() ?? '';
    this.leadDetailsService.getPaymentInfo(this.program?.program_code, id).subscribe((data: any) => {
      this.paymentInfo = data?.responsedata;
    });
  }
}
